/* eslint-disable import/prefer-default-export */
// eslint-disable-next-line consistent-return
export var handleKeyboardClick = function handleKeyboardClick(fn) {
  return function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      return fn(e);
    }
  };
};
export var getPopoverDirection = function getPopoverDirection(targetRect, popoverRect) {
  var offsetLeft = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var offsetBottom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var hasRects = targetRect && popoverRect;
  var collisions = {
    top: hasRects && targetRect.top - popoverRect.height < 0,
    right: hasRects && window.innerWidth < targetRect.left + popoverRect.width - offsetLeft,
    bottom: hasRects && window.innerHeight < targetRect.bottom + popoverRect.height - offsetBottom,
    left: hasRects && targetRect.left - popoverRect.width < 0
  };
  return {
    right: collisions.right && !collisions.left,
    up: collisions.bottom && !collisions.top
  };
};